import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Material } from 'src/app/models';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';

@Component({
  selector: 'mosaic-simple',
  templateUrl: './mosaic-simple.component.html',
  styleUrls: ['./mosaic-simple.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MosaicSimpleComponent {

  @Input('materiales') materiales: Material[] = [];
  @Output('onSelectMaterial') onSelectMaterial: EventEmitter<Material> = new EventEmitter<Material>();

  emitMaterial(material: Material): void {
    this.onSelectMaterial.emit(material);
  }

  get language(): Language {
    return getLanguage(getLanguageFromUrl());
  }
}
